const PATH = {
  AUTH: {
    LOGIN: '/',
    SIGN_UP: '/signup',
    FORGOT_PASSWORD: '/forgot-password',
    RECOVERPASSWORD: '/recover-password',
  },

  HOME: '/',
  MASTER_SCREEN: '/master-screen',
  PRODUCT_DEVELOPMENT: '/support-tracking-system',
  CLIENT_STS: '/sts',
  BUGS_SUGGESTIONS: '/bugs-suggestions',
  STS_US_ROBOTICS: '/us-robotics',
  COMMUNICATION_TRACKING_SYSTEM: '/communication-tracking-system',
  TIMESHEET_LOGS: '/timesheet-logs',
  TIMESHEET_APPROVAL: '/timesheet-approval',
  FIRST_TACTICAL: '/first-tactical',
  TEAMS: '/teams',
  USERS: '/users',
  CHANGE_USER_PASSWORD: '/change-user-password',
  CONSOLIDATE_REPORT: '/consolidate-report',
  BULK_TASK_UPLOAD: '/bulk-task-upload',

  VERSION_LOGS: '/version-logs',
  PROJECTS: '/projects',
  THEME_STUDIO: '/theme-studio',
  EMAIL_MAPPING: '/email-mapping',
};

export default PATH;
